import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import { SearchStats } from '@uncinc/react-searchkit';
import type { SearchStatsProps } from '@uncinc/react-searchkit/dist/components/Stats';

const SearchForumThreadStats: React.FC<SearchStatsProps> = (props) => {
  const { t } = useTranslation();
  const { className, ...restProps } = props;

  const classNames = c('SearchForumThread__Stats', 'text--small', className);

  return (
    <SearchStats
      {...restProps}
      className={classNames}
      translation={(count) => t('pages.forum_post_header.response_count_text', { count })}
    />
  );
};

export default SearchForumThreadStats;
